import Vue from 'vue'
import store from '@state/store'
import { success, fail } from '@/helpers/result-helper'

export default async function() {
  store.commit('signalr/START_LOADING')

  try {
    await Vue.prototype.$signalRHub.login(
      store.getters['signalr/getAccessToken'],
      store.getters['signalr/getWebSocketToken']
    )
    return success()
  } catch (ex) {
    console.error(ex)
    return fail(ex.response)
  } finally {
    store.commit('signalr/FINISH_LOADING')
  }
}
